










































































import { Component, Vue } from 'vue-property-decorator';
import { progress } from '@/script/progress';
import download from '@/infrastructure/api/download';
import ButtonPanel from '@/components/menu/panel/ButtonPanel.vue';
import IconButton from '@/components/atom/button/IconButton.vue';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';
import NormalButton from '@/components/atom/button/NormalButton.vue';
import YearMonthPicker from '@/components/datepicker/YearMonthPicker.vue';
import DepartmentSelector from '@/components/department/DepartmentSelector.vue';
import moment from 'moment';

import {定数在庫表出力依頼型} from '@/type/custom/goryoukaku/定数在庫表出力依頼型';
import 定数在庫表出力依頼チェッカー from '@/type/custom/goryoukaku/定数在庫表出力依頼チェッカー';
import {loginModule} from '@/store/authentication/login';
import {薬品受払表出力依頼型} from '@/type/custom/goryoukaku/薬品受払表出力依頼型';
import 薬品受払表出力依頼チェッカー from '@/type/custom/goryoukaku/薬品受払表出力依頼チェッカー';

@Component({
  components: {
    IconButton,
    ButtonPanel,
    ConfirmDialog,
    AlertDialog,
    NormalButton,
    YearMonthPicker,
    DepartmentSelector,
  },
})
export default class GoryoukakuReportOutput extends Vue {

  定数在庫表出力依頼: 定数在庫表出力依頼型 = this.デフォルトの定数在庫表出力依頼();
  薬品受払表出力依頼: 薬品受払表出力依頼型 = this.デフォルトの薬品受払表出力依頼();
  アラートメッセージ: string | string[] | null = null;

  created(): void {
    moment.locale('ja');
    this.initialize();
  }

  initialize() {
    this.定数在庫表出力依頼 = this.デフォルトの定数在庫表出力依頼();
    this.薬品受払表出力依頼 = this.デフォルトの薬品受払表出力依頼();
  }

  ダイアログを開く(name: string): void {
    this.$modal.show(name);
  }

  ダイアログを閉じる(name: string): void {
    this.$modal.hide(name);
  }

  デフォルトの定数在庫表出力依頼(): 定数在庫表出力依頼型 {
    return {
      在庫場所: loginModule.部署コードを取得する,
      チェック回数: 1,
    };
  }

  デフォルトの薬品受払表出力依頼(): 薬品受払表出力依頼型 {
    return {
      受払対象年月FROM: null,
      受払対象年月TO: null,
      出力コード区分: 'JANコード',
    };
  }

  async 定数在庫表を出力する(): Promise<void> {
    if (!this.定数在庫表出力依頼) {
      return;
    }
    const checker = new 定数在庫表出力依頼チェッカー(this.定数在庫表出力依頼);
    if (checker.hasErrors()) {
      this.ダイアログを閉じる('定数在庫表ダウンロード確認ダイアログ');
      this.showAlert(checker.errorMessages());
      return;
    }
    const now = new Date();
    await download.五稜郭病院定数在庫表を出力する('定数在庫表_' + moment(now).format('YYYYMMDDHHmmss') + '.xlsx', this.定数在庫表出力依頼)
            .catch((error: any) => {
              this.showAlert(error.data);
              return;
            });
    this.ダイアログを閉じる('定数在庫表ダウンロード確認ダイアログ');
  }

  async 定数在庫表を出力するハンドラ(): Promise<void> {
    await progress(this.定数在庫表を出力する);
  }

  async 薬品受払表を出力する(): Promise<void> {
    if (!this.薬品受払表出力依頼) {
      return;
    }
    const checker = new 薬品受払表出力依頼チェッカー(this.薬品受払表出力依頼);
    if (checker.hasErrors()) {
      this.ダイアログを閉じる('薬品受払表ダウンロード確認ダイアログ');
      this.showAlert(checker.errorMessages());
      return;
    }
    const now = new Date();
    await download.五稜郭病院薬品受払表を出力する('薬品受払表_' + moment(now).format('YYYYMMDDHHmmss') + '.xlsx', this.薬品受払表出力依頼)
            .catch((error: any) => {
              this.showAlert(error.data);
              return;
            });
    this.ダイアログを閉じる('薬品受払表ダウンロード確認ダイアログ');
  }

  async 薬品受払表を出力するハンドラ(): Promise<void> {
    await progress(this.薬品受払表を出力する);
  }

  APIアラートダイアログを開く(data: any) {
      this.アラートメッセージ = [data.message];
      if (data.errors !== null && data.errors !== undefined) {
        for (const エラー of data.errors) {
          this.アラートメッセージ = this.アラートメッセージ.concat(['・' + エラー]);
        }
      }
      this.$modal.show('アラート');
  }

  showAlert(message: string[] | string | null): void {
    this.アラートメッセージ = message;
    this.$modal.show('函館五稜郭病院個別帳票出力アラート');
  }

  get 定数在庫表が有効である(): boolean {
    return loginModule.定数在庫表_函館五稜郭病院が有効である;
  }

  get 薬品受払表が有効である(): boolean {
    return loginModule.薬品受払表_函館五稜郭病院が有効である;
  }

}
